import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import TrustBar from "@/components/TrustBar";
import { SPECIALISATIONS, MICROCEMENT_FEATURED, IMAGES } from "@/data/content";

export default function ServicesOverview() {
  return (
    <div>
      <section className="container-x pt-36 md:pt-44 pb-16 md:pb-20">
        <Overline className="mb-6">Our Specialisations</Overline>
        <h1 className="font-display text-5xl md:text-7xl lg:text-[6rem] font-extrabold leading-[0.9] tracking-tighter uppercase max-w-4xl">Specialist<br />Disciplines.</h1>
        <p className="mt-8 text-lg md:text-xl font-light text-taupe max-w-2xl leading-relaxed">Every CEMTEX discipline is held to a single, uncompromising standard. From seamless microcement to certified waterproofing, we treat each surface as architecture.</p>
      </section>

      <section className="container-x pb-24 md:pb-32">
        {/* Rows 1 & 2 — six disciplines */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {SPECIALISATIONS.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <Link to={s.to} data-testid={`overview-${s.testid}`} className="group block relative h-[420px] overflow-hidden">
                <img src={s.image} alt={s.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <div className="absolute inset-0 p-6 flex flex-col justify-end text-white">
                  <span className="font-mono text-xs text-white/50 mb-2">{s.index}</span>
                  <h3 className="font-display text-2xl md:text-3xl font-bold mb-1">{s.title}</h3>
                  <p className="text-[0.7rem] uppercase tracking-[0.18em] text-white/60">{s.tagline}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        {/* Row 3 — Microcement featured */}
        <Reveal delay={0.1}>
          <Link to={MICROCEMENT_FEATURED.to} data-testid="overview-service-microcement" className="group mt-4 relative block h-[320px] overflow-hidden">
            <img src={MICROCEMENT_FEATURED.image} alt="Microcement" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/30" />
            <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-center text-white max-w-2xl">
              <span className="font-mono text-xs text-white/50 mb-2">07</span>
              <h3 className="font-display text-4xl md:text-5xl font-bold mb-2">{MICROCEMENT_FEATURED.title}</h3>
              <p className="text-white/70 font-light">{MICROCEMENT_FEATURED.desc}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-sand">Explore Microcement <ArrowRight className="h-4 w-4" /></span>
            </div>
          </Link>
        </Reveal>
      </section>

      <TrustBar dark />

      <section className="relative py-32 md:py-40 overflow-hidden" data-testid="services-cta">
        <img src={IMAGES.concreteStairs} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-charcoal/80" />
        <div className="relative container-x text-center text-white">
          <h2 className="font-display text-4xl md:text-6xl font-extrabold mb-8">Ready to begin?</h2>
          <CTAButton to="/contact" testid="services-cta-button" variant="accent">Get a Free Quote</CTAButton>
        </div>
      </section>
    </div>
  );
}
